import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import AdminProtectedRoute from './ProtectedRoute';
import AdminLayout from './layouts/AdminLayout';

// Admin Pages
import AdminOnboarding from './pages/onboarding';
import AdminDashboard from './pages/dashboard';
import CatererManagementPage from './pages/caterers';
import CustomerManagementPage from './pages/customers';
import OrderManagementPage from './pages/orders';
import PaymentsPage from './pages/payments';
import EscrowsPage from './pages/escrows';
import BidsPage from './pages/bids';
import PayoutsPage from './pages/payouts';
import EventsPage from './pages/events';
import PlatformHealthPage from './pages/platform';
import AnalyticsInsightsPage from './pages/analytics';
import ComplianceRequestsPage from './pages/compliance';
import ObservabilityPage from './pages/observability';
import AdminSettingsPage from './pages/settings';
import EscalationCentrePage from './pages/escalations';
import SupportPage from './pages/support';
import NotifyUsersPage from './pages/notify-users';
import CatererClaimsPage from './pages/caterer-claims';

/**
 * All routes for admin users
 * Base path: /admin
 */
export default function AdminRoutes() {
  return (
    <Routes>
      {/* Admin Onboarding */}
      <Route path="onboarding" element={<AdminOnboarding />} />

      {/* Protected Admin Routes */}
      <Route
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="orders" element={<OrderManagementPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="escrows" element={<EscrowsPage />} />
        <Route path="bids" element={<BidsPage />} />
        <Route path="payouts" element={<PayoutsPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="caterers" element={<CatererManagementPage />} />
        <Route path="caterer-claims" element={<CatererClaimsPage />} />
        <Route path="customers" element={<CustomerManagementPage />} />
        <Route path="compliance" element={<ComplianceRequestsPage />} />
        <Route path="platform" element={<PlatformHealthPage />} />
        <Route path="analytics" element={<AnalyticsInsightsPage />} />
        <Route path="observability" element={<ObservabilityPage />} />
        <Route path="escalations" element={<EscalationCentrePage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="notify-users" element={<NotifyUsersPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
      </Route>

      {/* Default redirect */}
      <Route index element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
}
